<template>
  <div>
  </div>

</template>

<script>
// @todo just loading here saves the redirected
import { handleAuthentication } from '../lib/ad.azure.auth';

  export default {
    data: () => ({
      handleAuthentication: null
    }),
    props: {
      source: String
    },
    methods: {
      
    },
    mounted() {
      this.handleAuthentication = handleAuthentication;

      
    }
  }
</script>
